import styled from "styled-components";
import { useTranslation } from "react-i18next";
import {
  Table,
  TableHeader,
  TableHeaderCell,
  TableBody,
  TableRow,
  TableCell,
} from "../../../components/Table";
import { spacing } from "@styling/sizing";
import { fontSizes } from "@styling/fonts";
import colors from "@styling/colors";
import type { ImportValidGiftCard } from "../../../api/giftcardsApi";
import { formatMoney } from "../../../utils/formatMoney";
import { formatDate } from "../../../utils/dateUtils";

const ProductsTitle = styled.h4`
  margin: ${spacing.x3}px 0 ${spacing.x2}px 0;
  font-size: ${fontSizes.regular}px;
  font-weight: 600;
  color: ${colors.text};
`;

interface ValidGiftcardsTableProps {
  giftcards: ImportValidGiftCard[];
}

export const ValidGiftcardsTable = ({ giftcards }: ValidGiftcardsTableProps) => {
  const { t } = useTranslation();

  if (giftcards.length === 0) {
    return null;
  }

  return (
    <>
      <ProductsTitle>{t("giftcardImport.validGiftcardsPreview")}</ProductsTitle>
      <Table>
        <TableHeader>
          <tr>
            <TableHeaderCell>{t("giftcardImport.validCardNumber")}</TableHeaderCell>
            <TableHeaderCell align="right">{t("giftcardImport.validInitialAmount")}</TableHeaderCell>
            <TableHeaderCell align="right">{t("giftcardImport.validRemainingAmount")}</TableHeaderCell>
            <TableHeaderCell>{t("giftcardImport.validValidUntil")}</TableHeaderCell>
            <TableHeaderCell>{t("giftcardImport.validStatus")}</TableHeaderCell>
          </tr>
        </TableHeader>
        <TableBody>
          {giftcards.map((gc, index) => (
            <TableRow key={index}>
              <TableCell noWrap>{gc.cardNumber ?? "–"}</TableCell>
              <TableCell noWrap align="right">
                {gc.initialAmount ? formatMoney(gc.initialAmount) : "–"}
              </TableCell>
              <TableCell noWrap align="right">
                {gc.remainingAmount ? formatMoney(gc.remainingAmount) : "–"}
              </TableCell>
              <TableCell noWrap>
                {gc.validUntil ? formatDate(gc.validUntil) : "–"}
              </TableCell>
              <TableCell noWrap>{gc.status ?? "–"}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
};
